/* src/components/ServicesSection.js */
import React, { useContext } from "react";
import "./ServicesSection.css";
import { MODE, getTEXT, getMarketingLabel } from "../config/compliance";
import { LangContext } from "../lang/LangProvider";

// Icone SVG minimali (ereditano colore dal CSS)
const iconProps = {
  width: 28,
  height: 28,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
  focusable: false,
};

const baseIcons = [
  // 1) Pie / Analisi portafoglio
  (
    <svg {...iconProps}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 12V3a9 9 0 0 1 9 9h-9z" />
    </svg>
  ),
  // 2) Ricerca / Lente
  (
    <svg {...iconProps}>
      <circle cx="11" cy="11" r="7" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  ),
  // 3) Grafico lineare / Quant
  (
    <svg {...iconProps}>
      <path d="M3 3v18h18" />
      <path d="M7 15l5-5 4 4 4-6" />
    </svg>
  ),
  // 4) Formazione / Tocco
  (
    <svg {...iconProps}>
      <path d="M12 3l9 5-9 5-9-5 9-5z" />
      <path d="M19 10v6a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3v-6" />
    </svg>
  ),
  // 5) Soluzioni digitali / Sliders
  (
    <svg {...iconProps}>
      <line x1="4" y1="21" x2="4" y2="14" />
      <line x1="4" y1="10" x2="4" y2="3" />
      <circle cx="4" cy="12" r="2" />
      <line x1="12" y1="21" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12" y2="3" />
      <circle cx="12" cy="10" r="2" />
      <line x1="20" y1="21" x2="20" y2="16" />
      <line x1="20" y1="12" x2="20" y2="3" />
      <circle cx="20" cy="14" r="2" />
    </svg>
  ),
  // 6) Compliance / Shield
  (
    <svg {...iconProps}>
      <path d="M12 22s-7-3.5-7-10V5l7-3 7 3v7c0 6.5-7 10-7 10z" />
    </svg>
  ),
];

export default function ServicesSection() {
  // ✅ Hooks SOLO dentro al componente
  const { lang } = useContext(LangContext);

  // ✅ Testi e label dipendono dalla lingua
  const TEXT_CONF = getTEXT(lang);
  const items = TEXT_CONF[MODE]?.services || [];
  const marketingLabel = getMarketingLabel(lang);

  // Servizio di consulenza non avviato: la sezione descrive ciò che il sito offre davvero.
  const title =
    MODE === "EDU"
      ? lang === "en"
        ? "Quantitative Solutions for Investors"
        : "Soluzioni Quantitative per Investitori"
      : lang === "en"
      ? "What you will find on the site"
      : "Cosa trovi sul sito";

  return (
    <section className="services-section" aria-label={marketingLabel}>
      <h2 className="services-title">{title}</h2>

      <div className="services-grid">
        {items.map((s, i) => (
          <div key={i} className="service-card">
            <div className="service-icon">{baseIcons[i % baseIcons.length]}</div>
            <h3 className="service-name">{s.title}</h3>
            <div className="service-underline"></div>
            <p className="service-desc">{s.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
